import { StyleSheet, View } from 'react-native';

import { Text } from '@/components/ui';
import { useTheme } from '@/theme';

export type Bar = { label: string; value: number };

export function BarChart({
  data,
  format = (n: number) => String(n),
  highlightLast = true,
  title,
}: {
  data: Bar[];
  format?: (n: number) => string;
  highlightLast?: boolean;
  title?: string;
}) {
  const theme = useTheme();
  const max = Math.max(1, ...data.map((d) => d.value));

  return (
    <View
      style={[
        styles.outer,
        { backgroundColor: theme.colors.bgSoft, borderRadius: theme.radii.md, borderColor: theme.colors.rule },
      ]}
    >
      {title ? (
        <Text variant="eyebrow" tone="fgMute" style={{ marginBottom: 16 }}>
          {title}
        </Text>
      ) : null}
      <View style={styles.bars}>
        {data.map((d, i) => {
          const isLast = i === data.length - 1 && highlightLast;
          const h = Math.max(4, Math.round((d.value / max) * 160));
          return (
            <View key={d.label + i} style={styles.col}>
              <View style={styles.barTrack}>
                <View
                  style={[
                    styles.bar,
                    {
                      height: h,
                      backgroundColor: isLast ? theme.colors.accentAlt : theme.colors.accent,
                    },
                  ]}
                />
              </View>
              <Text variant="meta" tone="fgMute" style={{ marginTop: 8 }}>{d.label}</Text>
              <Text variant="small" style={{ marginTop: 2 }}>{format(d.value)}</Text>
            </View>
          );
        })}
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  outer: {
    padding: 24,
    borderWidth: 1,
  },
  bars: {
    flexDirection: 'row',
    alignItems: 'flex-end',
    gap: 12,
    height: 220,
  },
  col: {
    flex: 1,
    alignItems: 'center',
  },
  barTrack: {
    flex: 1,
    width: '100%',
    justifyContent: 'flex-end',
  },
  bar: {
    width: '100%',
    borderRadius: 4,
  },
});
